import { CONST } from '../_config';
import { authHeader } from '../_helpers';
import FileDownload from "js-file-download";
import Axios from "axios";
import CryptoJS from 'crypto-js';


export const assessmentService = {
    userAssessmentUserProfile,
    assessmentLogout,
    userAssessmentPackageBuy,
    userAssessmentOrders,
    userAssessmentSurveyLogin,

    userAssessmentSurveyLoginByOTP,

    getAssessmentPackagesList,
    getAssessmentPackagesById,
    assessmentAddToCart,
    getAssessmentCartItems,
    updateCartItemQuantity,
    getAssessmentCartPriceTotal,
    deleteCartItem,
    getOrderBookList,
    userAssessmentResponseAnalytics,
    userAssessmentOrderNameUpdate,
    getAssessmentCartCount,
    saveAssessmentContactUs,
    updateAssessmentUserProfile,
    assessmentDownloadStatus,
    getAssessmentPackagesShortList,
    getUserAssessmentLangReport
};
function assessmentLogout() {
    localStorage.removeItem('adminuser');
    window.location.href = "#/assessment/signin";
    window.location.reload();
}
function logout() {
    localStorage.removeItem('adminuser');
    // window.location.href = "#/login";
    // window.location.reload();

}
function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                logout();
            }
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        if (data.error) {
            if (data.code === 3) {
                logout();
            }
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}

async function getUserAssessmentLangReport(value) {
    return Axios({
        url: (CONST.BACKEND_URL) + `/emprole/getAssessmentReport`,
        method: 'POST',
        responseType: "blob",
        headers: {
            'Content-Type': 'application/json',
            "authorization": authHeader().Authorization
        },
        data: value
    }).then((res) => {

        FileDownload(res.data, "Assessment.pdf")

        let ProfileObj = {
            getType2AssessmentReportByEmpIDDara: []
        }
        return ProfileObj;
    })
}


function userAssessmentUserProfile(data) {

    let header = new Headers({
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/emprole/userAssessmentUserProfile`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let questionObj = {
                userAssessmentUserProfileData: data.data
            }
            return questionObj;
        });
}





function userAssessmentPackageBuy(data) {

    let header = new Headers({
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/emprole/userAssessmentPackageBuy`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let questionObj = {
                userAssessmentPackageBuyData: data.data
            }
            return questionObj;
        });
}




function userAssessmentOrders(data) {

    let header = new Headers({
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/emprole/userAssessmentOrders`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let questionObj = {
                userAssessmentOrdersData: data.data
            }
            return questionObj;
        });
}


function userAssessmentSurveyLogin(data) {

    let header = new Headers({
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/emprole/userAssessmentSurveyLogin`, requestOptions)
        .then(handleResponse)
        .then(assessment => {
            let questionObj = {
                userAssessmentSurveyLoginData: assessment.data
            }

            if (assessment.data) {

                localStorage.setItem('adminuser', JSON.stringify(assessment.data));
            }
            return questionObj;
        });
}


function userAssessmentSurveyLoginByOTP(data) {

    let header = new Headers({
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/emprole/userAssessmentSurveyLoginByOTP`, requestOptions)
        .then(handleResponse)
        .then(assessment => {
            let questionObj = {
                userAssessmentSurveyLoginByOTPData: assessment.data
            }

            if (assessment.data) {

                localStorage.setItem('adminuser', JSON.stringify(assessment.data));
            }
            return questionObj;
        });
}

function getAssessmentPackagesList(data) {

    let header = new Headers({
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/emprole/getAssessmentPackagesList`, requestOptions)
        .then(handleResponse)
        .then(assessment => {
            let questionObj = {
                getAssessmentPackagesListData: assessment.data
            }
            return questionObj;
        });
}

function getAssessmentPackagesById(data) {

    let header = new Headers({
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/emprole/getAssessmentPackagesById`, requestOptions)
        .then(handleResponse)
        .then(assessment => {
            let questionObj = {
                getAssessmentPackagesByIdData: assessment.data
            }
            return questionObj;
        });
}

function assessmentAddToCart(data) {

    let header = new Headers({
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/emprole/assessmentAddToCart`, requestOptions)
        .then(handleResponse)
        .then(assessment => {
            let questionObj = {
                assessmentAddToCartData: assessment.data
            }
            return questionObj;
        });
}

function getAssessmentCartItems(data) {

    let header = new Headers({
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/emprole/getAssessmentCartItems`, requestOptions)
        .then(handleResponse)
        .then(assessment => {
            let questionObj = {
                getAssessmentCartItemsData: assessment.data
            }
            return questionObj;
        });
}

function updateCartItemQuantity(data) {

    let header = new Headers({
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/emprole/updateCartItemQuantity`, requestOptions)
        .then(handleResponse)
        .then(assessment => {
            let questionObj = {
                updateCartItemQuantityData: assessment.data
            }
            return questionObj;
        });
}

function getAssessmentCartPriceTotal(data) {

    let header = new Headers({
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/emprole/getAssessmentCartPriceTotal`, requestOptions)
        .then(handleResponse)
        .then(assessment => {
            let questionObj = {
                getAssessmentCartPriceTotalData: assessment.data
            }
            return questionObj;
        });
}

function deleteCartItem(data) {

    let header = new Headers({
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/emprole/deleteCartItem`, requestOptions)
        .then(handleResponse)
        .then(assessment => {
            let questionObj = {
                deleteCartItemData: assessment.data
            }
            return questionObj;
        });
}

function getOrderBookList(data) {

    let header = new Headers({
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/emprole/getOrderBookList`, requestOptions)
        .then(handleResponse)
        .then(assessment => {
            let questionObj = {
                getOrderBookListData: assessment.data
            }
            return questionObj;
        });
}


function userAssessmentResponseAnalytics(data) {

    let header = new Headers({
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/emprole/userAssessmentResponseAnalytics`, requestOptions)
        .then(handleResponse)
        .then(assessment => {
            let questionObj = {
                userAssessmentResponseAnalyticsData: assessment.data
            }
            return questionObj;
        });
}


function userAssessmentOrderNameUpdate(data) {

    let header = new Headers({
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/emprole/userAssessmentOrderNameUpdate`, requestOptions)
        .then(handleResponse)
        .then(assessment => {
            let questionObj = {
                userAssessmentOrderNameUpdateData: assessment.data
            }
            return questionObj;
        });
}

function getAssessmentCartCount(data) {

    let header = new Headers({
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/emprole/getAssessmentCartCount`, requestOptions)
        .then(handleResponse)
        .then(assessment => {
            let questionObj = {
                getAssessmentCartCountData: assessment.data
            }
            return questionObj;
        });
}




function saveAssessmentContactUs(data) {

    let header = new Headers({
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/emprole/saveAssessmentContactUs`, requestOptions)
        .then(handleResponse)
        .then(assessment => {
            let questionObj = {
                saveAssessmentContactUsData: assessment.data
            }
            return questionObj;
        });
}


function updateAssessmentUserProfile(data) {

    let header = new Headers({
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/emprole/updateAssessmentUserProfile`, requestOptions)
        .then(handleResponse)
        .then(assessment => {
            let questionObj = {
                updateAssessmentUserProfileData: assessment.data
            }
            return questionObj;
        });
}
function assessmentDownloadStatus(data) {

    let header = new Headers({
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/emprole/assessmentDownloadStatus`, requestOptions)
        .then(handleResponse)
        .then(assessment => {
            let questionObj = {
                assessmentDownloadStatusData: assessment.data
            }
            return questionObj;
        });
}
function getAssessmentPackagesShortList(data) {

    let header = new Headers({
        'Content-Type': 'application/json',
        'Authorization': authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/emprole/getAssessmentPackagesShortList`, requestOptions)
        .then(handleResponse)
        .then(assessment => {
            let questionObj = {
                getAssessmentPackagesShortListData: assessment.data
            }
            return questionObj;
        });
}